import { useTranslation } from 'react-i18next';
import { HeaderBreadcrumbsProps } from 'src/components/HeaderBreadcrumbs';
import { NotificationEditLayout } from '../components/pages/edit/components/NotificationEditLayout';

export const NotificationEditPage = () => {
  const { t } = useTranslation();
  const pageTitle = t('notifications.editPage.pageTitle');

  const breadcrumbs: HeaderBreadcrumbsProps = {
    heading: t('notifications.editPage.pageTitle'),
    links: [
      { name: 'TOP', href: '/top' },
      { name: t('notifications.editListPage.pageTitle'), href: '/manage/notification/edit' },
    ],
    activeLast: true,
  };

  return <NotificationEditLayout pageTitle={pageTitle} breadCrumbs={breadcrumbs} />;
};
